import callAPiBase from './base';

const userTagsApi = {
  get: ({ Room }: { Room: string }) =>
    callAPiBase({
      endpoint: `/api/tags/users?Room=${encodeURIComponent(Room)}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/tags/user',
      method: 'POST',
      useToken: true,
      data,
    }),
  delete: ({ ID, room }: { ID: string; room: string }) =>
    callAPiBase({
      endpoint: `/api/tags/user?ID=${ID}&room=${encodeURIComponent(room)}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { userTagsApi };
export default userTagsApi;
